const CURRENCY_SYMBOLS: Record<string, string> = {
    EUR: '\u20ac',
    USD: '$',
    GBP: '\u00a3',
    JPY: '\u00a5',
    CHF: 'CHF',
    SEK: 'kr',
    NOK: 'kr',
    DKK: 'kr',
    PLN: 'z\u0142',
    CZK: 'K\u010d',
    CAD: 'CA$',
    AUD: 'A$',
}

export function currencySymbol(currencyCode: string): string {
    return CURRENCY_SYMBOLS[currencyCode] || currencyCode
}

export function formatCurrency(amount: string | number, currencyCode: string): string {
    const num = typeof amount === 'string' ? parseFloat(amount) : amount
    if (isNaN(num)) return `${currencySymbol(currencyCode)}0.00`
    return `${currencySymbol(currencyCode)}${num.toFixed(2)}`
}
